import React from 'react';
import { MEDIA_TYPE } from '@whatsper/texterchat-common';
import styles from '../MessengerMessage.module.scss';
import PostPreview from './PostPreview';
const Comment = ({ feedComment }) => {
    let inlineMedia;
    if (feedComment.photo) {
        inlineMedia = { url: feedComment.photo, mediaType: MEDIA_TYPE.IMAGE };
    }
    if (feedComment.video) {
        inlineMedia = { url: feedComment.video, mediaType: MEDIA_TYPE.VIDEO };
    }
    return (React.createElement("div", { className: styles.messageContainer },
        React.createElement("div", null, feedComment.message),
        (inlineMedia === null || inlineMedia === void 0 ? void 0 : inlineMedia.url) && React.createElement(PostPreview, { url: inlineMedia.url, type: inlineMedia.mediaType })));
};
export default Comment;
